import { useNavigate, useQueryState } from '@/routing'
import { FormattedMessage } from 'react-intl'

import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material'

import { useLiveEtaStatus } from '../../../../../../hooks/useLiveEtaStatus'

import { useCallback } from 'react'
import { useTexts } from './useTexts'

import type { Notifications } from '../../../../../types'

export function NotificationLimitations() {
  const liveEtaStatus = useLiveEtaStatus()
  const texts = useTexts()
  const navigate = useNavigate(true)
  const [, setQuery] = useQueryState<Notifications>('notification')

  const navigateToVehicles = useCallback(() => {
    navigate('vehicles')
  }, [navigate])

  const navigateToOrderScheduledToday = useCallback(() => {
    setQuery('todaySettings')
  }, [setQuery])

  // If the user is 360Legacy (no Live ETA)
  if (liveEtaStatus === 'notAvailableForTheUser')
    return (
      <Alert severity="warning">
        <AlertTitle>{texts.liveEtaNotAvailableForUserTitle}</AlertTitle>
        {texts.liveEtaNotAvailableForUserDescription}
      </Alert>
    )

  // If Live ETA is not enabled on the Territory let's return just the alert
  if (liveEtaStatus === 'notActive')
    return (
      <Alert severity="error">
        <AlertTitle>{texts.liveEtaRequiredTitle}</AlertTitle>
        {texts.liveEtaRequiredDescription}
      </Alert>
    )

  return (
    <>
      <Alert severity="warning">
        <AlertTitle>{texts.notificationLimitationTitle}</AlertTitle>
        <Stack direction="column" spacing={1} alignItems="start">
          <Typography variant="body2">{texts.notificationLimitationDescription}</Typography>
          <Button variant="text" onClick={navigateToOrderScheduledToday}>
            {texts.navigateToOrderScheduledTodayLabel}
          </Button>
        </Stack>
      </Alert>

      {liveEtaStatus === 'notActiveOnAllVehicles' && (
        <Alert severity="info">
          <AlertTitle>{texts.liveEtaRequiredOnAllVehiclesTitle}</AlertTitle>

          <Stack direction="column" spacing={1} alignItems="start">
            <Typography variant="body2">
              <FormattedMessage
                id="info-description"
                defaultMessage={texts.liveEtaRequiredOnAllVehiclesDescription}
                values={{
                  b: chunks => (
                    <Typography fontWeight={500} display="inline">
                      {chunks}
                    </Typography>
                  ),
                  br: _ => <br />,
                }}
              />
            </Typography>
            <Button variant="text" onClick={navigateToVehicles}>
              {texts.navigateToVehiclesLabel}
            </Button>
          </Stack>
        </Alert>
      )}
    </>
  )
}
